export default {
    list: {
        orderId: 'Order Number',
        pfm: 'PFM Store Code',
        dateCreate: 'Date of creation',
        orderStatusId: 'Processing status',
        deliveryServiceTypeId: 'Type of delivery',
        payTypeId: 'Payment type',
        sourceType: 'Order source',
        userAuthorization: 'User status',
        name: 'Name',
        email: 'Email',
        accuracy: 'Order Accuracy',
        orderInfo: 'Order Information',
        integrity: 'Order integrity',
        equipment: 'Order picking',
        comment: 'Comment',
        rating: 'Rating',
        deliveryServiceType: 'Delivery service type',
        payType: 'Payment type',
        orderSourceType: 'Order source',
        orderStatus: 'Order status',
    },
    filter: {
        deliveryServiceTypes: {
            placeholder: 'Type of delivery',
            text: 'Selected delivery types',
        },
        payTypes: {
            placeholder: 'Payment type',
            text: 'Payment types selected',
        },
        orderSourceTypes: {
            placeholder: 'Order source',
            text: 'Order sources selected',
        },
        userAuthorization: {
            placeholder: 'User status',
            text: 'User statuses selected',
        },
        rating: {
            placeholder: 'Rating',
            text: 'Ratings selected',
        },
        dateCreateFrom: 'Date of creation: from',
        dateCreateTo: 'Date of creation: before',
        orderId: 'Order Number',
        pfm: 'PFM Store Code',
        language: 'Language',
    },
    catalog: {
        'boolean': {
            yes: 'Yes',
            no: 'No',
        },
    },
    questions: {
        pickUp: {
            text: 'Question for self-collection',
            accuracy: 'Did the store staff assemble your order within 15 minutes?',
            orderInfo: 'Did they text you when your order was ready?',
            integrity: 'Did the condition of the items meet your expectations?',
            equipment: 'Was the order assembled correctly?',
            rating: 'How did your last order go?',
        },
        delivery: {
            text: 'Question for delivery',
            accuracy: 'Did you receive your order on the selected date?',
            orderInfo: 'Did you receive an SMS with information about your order?',
            integrity: 'Is the condition of the goods in accordance with your expectations?',
            equipment: 'Was the order packed correctly?',
            rating: 'How was your last order?',
        },
    },
};